import type { FaireProductEntity } from "../../entity_types/product";

export const p_je79wxss9z: FaireProductEntity = {
  token: "p_je79wxss9z",
  type: "product",
  name: "Coconut Oil Shampoo & Conditioner Bar Combo for Dry Damaged Hair",
  brandToken: "b_dljmfs9o",
  brandName: "KITSCH",
  imageUrl:
    "https://cdn.faire.com/fastly/253463a29715d671024488edb78bc3c61ca8385c38e0d0f9b91ec8409c28f4e9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3fe8d5686e234206dc894c641e6c375f0b95c817d44e54c2767bdfed859f272e.jpeg",
    "https://cdn.faire.com/fastly/c8773bc94eddb5a885ee95b8dbcee1a8b63ee1684a47d6ed69871798db4bf9a0.png",
    "https://cdn.faire.com/fastly/76def43036ec3e9a1e099a4f496d34ad7d6c457c3cfd69c79f155ff2e7f771ce.jpeg",
    "https://cdn.faire.com/fastly/04caa047a85379798cb427f4066ade68adeddb1a5a2cbee597dfa0d74b093263.jpeg",
    "https://cdn.faire.com/fastly/0a32f544cb3d9fba014fc2dd459fa02cdec043a966dfad7684b597b1d3156d2a.png",
    "https://cdn.faire.com/fastly/05bc3c20e3d04d32fde1e6992e071d438f0dcd6a5f5e38881707227ad6053f8a.jpeg",
  ],
  priceDollars: 19.4,
  description:
    "\n * Formulated with Coconut Oil known to boost hydration \n * Formulated with Fision® EcoSil clinically proven to increase shine after 5 uses \n * Deeply cleanses and moisturizes kinky, curly, and coily hair from roots to ends \n * Formulated to support a healthier-feeling, more balanced scalp for stronger, revitalized hair \n * Perfect for Kinky, Curly, & Coily Hair \nDisclaimer: Packaging received may vary from packaging shown.\n\nWHY YOU'LL LOVE THIS\n\n * Helps gently smooth knots and tangles for less damage and breakage while brushing \n * Free of parabens, phthalates, silicones, sulfates & artificial fragrance \n * pH balanced and safe for color-treated hair \n * Reduces single-use plastic bottles: our concentrated bar formula has the active ingredients equivalent to two 16oz bottles or one 32oz bottle of liquid conditioner \n * Made in the USA, Vegan, Cruelty Free, Leaping Bunny Certified \n * 4OCEAN CERTIFIED: For every shampoo or conditioner bar, 4ocean pulls the equivalent of one conditioner bottle's worth of plastic from the world's oceans, rivers, and coastlines \n",
  tags: [],
  msrpDollars: 38.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:02:09.391Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
